var exports = {
  "kL": "container__ia20D8",
  "R_": "heading__NMVZ-E",
  "ne": "controls__DLu5pH",
};

module.exports = exports;
